// @flow
import React from 'react';
import styled from 'styled-components';
import { Avatar } from 'client-web-app/components';
import { colors } from 'bench-style-constants';

const SidebarCompanyHeaderText = styled.div`
  display: none;
  transition: color 0.2s ease-in-out;

  @media (min-width: 1441px) {
    color: ${colors.stone};
    display: block;
    font-size: 16px;
    padding-left: 16px;
  }
`;

const SidebarCompanyHeaderLayout = styled.button`
  -webkit-appearance: none;
  align-items: center;
  background: transparent;
  border: 0;
  display: flex;
  justify-content: center;
  padding: 16px 12px;
  width: 100%;

  &:focus {
    outline: 0;
  }

  &:hover > ${SidebarCompanyHeaderText} {
    color: ${colors.white};
  }

  @media (min-width: 1441px) {
    justify-content: flex-start;
    line-height: 16px;
    text-align: left;
  }
`;

type SidebarCompanyHeaderProps = {
  companyName: string,
  notificationCount: number,
  onClick?: () => void,
  dataTestId: string,
};

const SidebarCompanyHeader = ({
  companyName,
  notificationCount,
  onClick,
  dataTestId,
}: SidebarCompanyHeaderProps) => (
  <SidebarCompanyHeaderLayout data-test-id={dataTestId} onClick={onClick}>
    <Avatar
      textColor={colors.charcoal}
      size="40px"
      fontSize="16px"
      fontWeight="normal"
      backgroundColor={colors.stone}
      name={companyName}
      notificationCount={notificationCount}
    />
    <SidebarCompanyHeaderText>{companyName}</SidebarCompanyHeaderText>
  </SidebarCompanyHeaderLayout>
);

SidebarCompanyHeader.defaultProps = {
  onClick: undefined,
};

export default SidebarCompanyHeader;
